import axios from '@/utils/axios'

export default async function GetFeaturedCategories() {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/categories/get-featured-categories',
  )
  return data
}
